import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Vehicule } from 'src/app/model/data-managemnt';
import { MapService } from 'src/app/utils/leaflet/service/map.service';
import { DataManagementService } from '../../data-management/data-management.service';
import { HistoricalService } from '../../historical/historical.service';
import * as L from 'leaflet';
import Marker = L.Marker;
import { DatePipe } from '@angular/common';
import { GlobalService } from 'src/app/global.config';
import { PromptComponent } from '../prompt/prompt.component';
import {AlertController, ModalController, PopoverController} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import {TrackControleComponent} from "../../../utils/leaflet/track-controle/track-controle.component";
import { StartNavigation } from "@proteansoftware/capacitor-start-navigation";


@Injectable({
  providedIn: 'root'
})
export class PopupService {
  id1: any;
  playbackIndex: number = 0;
  playbackInterval: any;
  playbackStarted: boolean = true;
  polyline: any;
  endMarker: Marker;
  currentPlaybackMarker: Marker;
  id2: any;
  liveReloadingRT: any
  currentPathClickedDeviceId: number;
  isCurrentPathClicked: boolean;
  positionMarker: any;
  circle: any;
  isClicked: boolean = false;
  hideCurrentPath: boolean = true
  currentlocationlat: any;
  currentlocationlng: any;
  marker: any
  showBackButton: boolean = false
  constructor(
    private router: Router,
    private dataManagementService: DataManagementService,
    private mapService: MapService,
    private historicalService: HistoricalService,
    private globalService: GlobalService,
    private popoverCtrl: PopoverController,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    private modalController: ModalController,
    private datePipe:DatePipe
  ) { }


  getVehicule(idDevice: number): Vehicule[] {
    let foundVehicule :any[] =[];
    if (!this.dataManagementService.groups)
      return [];
    for (let i = 0; i < this.dataManagementService.groups.length; i++) {
      for (let j = 0; j < this.dataManagementService.groups[i].vehicules.length; j++) {
        if (this.dataManagementService.groups[i].vehicules[j].device != null &&
          this.dataManagementService.groups[i].vehicules[j].device.idDevice === idDevice) {
          foundVehicule.push(this.dataManagementService.groups[i].vehicules[j] as never);
        }
      }
    }
    return foundVehicule;

  }

  voirHistorique() {
    this.hideCurrentPath = true
    this.router.navigate(['/path']);
  }


  /**
   * Open track control modal instead of navigating to a new page
   */
  async openTrackControlModal(playBackPath: any, trackType: string) {
    const modal = await this.modalController.create({
      component: TrackControleComponent,
      componentProps: {
        trackData: playBackPath,
        trackType: trackType
      },
      cssClass: 'track-control-modal',
      backdropDismiss: true,
      showBackdrop: true
    });
    modal.onDidDismiss().then(() => {
      modal.dismiss();
    })

    await modal.present();

    // Handle modal dismissal if needed
    const { data } = await modal.onWillDismiss();
    if (data) {
      console.log('Modal dismissed with data:', data);
      // Handle any data returned from the modal
    }
  }
  displayTodaysMileage(vehicule: Vehicule) {
    // this.showBackButton = true
    // this.hideCurrentPath = true
    // this.mapService.removePolylinesFromMap();
    // this.mapService.removeMarkersFromMap();
    let today = new Date();
    this.historicalService
      .getAllMileages(vehicule.idDevice, {
        startDate: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          0,
          0,
          0
        ),
        endDate: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          23,
          59,
          59
        )
      })
      .subscribe(
        mileages => {
          vehicule.mileage = this.historicalService.mileages[mileages.length - 1];
        },
        () => { }
      );

    let date = new Date();
    date.setHours(0, 0, 0, 0);
    let startHour: any = date.getTime();
    this.historicalService
      .getTodaysMileage(vehicule.device.idDevice, {
        startDate: startHour,
        endDate: startHour
      })
      .subscribe(
        mileage => {
          console.log("this is mileage", mileage);
          this.openTrackControlModal(mileage,"mileage");
        });
  }


  async arreterDemarrer(ev: any, vehic: any) {
    this.hideCurrentPath = true
    let vehicule = vehic.idDevice;
    let group = this.dataManagementService.selectedGroup;
    let selectedV = { "group": group, "vehicule": vehicule, "indexGroup": this.id1, "indexVehicule": this.id2 };

    let popover = await this.popoverCtrl.create({
      component: PromptComponent,
      event: ev,
      translucent: false,
      cssClass: 'marcheArret'
    });
    return await popover.present();
  }



  displayCurrentPath(deviceId: number) {
    this.showBackButton = true;
    this.hideCurrentPath = false;
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    this.isCurrentPathClicked = false; // Reset the flag

    this.historicalService.getCurrentPath(deviceId).subscribe({
      next: (currentPath) => {
        console.log("this is current path", currentPath);
        if (currentPath != null) {
          this.openTrackControlModal(currentPath, "currentkm");
        }
      },
      error: (err) => {
        console.error("Erreur lors de la récupération du chemin actuel", err);
        // Autres actions de gestion d’erreur si nécessaire
      }
    });
  }

  startPlayback(polyline: any) {
    this.playbackStarted = !this.playbackStarted; // Set to true when starting
    console.log(this.playbackStarted);
    this.playbackIndex = 0;

    // Remove any existing playback interval
    this.stopPlayback();

    // Start playback
    this.playbackInterval = setInterval(() => {
      if (this.playbackIndex < polyline.getLatLngs().length) {
        let currentPosition = polyline.getLatLngs()[this.playbackIndex];
        this.mapService.map.panTo(currentPosition);

        // Move current playback marker to the current position
        this.currentPlaybackMarker.setLatLng(currentPosition);

        // Access latitude and longitude from currentPosition
        let latitude = currentPosition.lat;
        let longitude = currentPosition.lng;

        // Access time and startTime from currentPath (assuming currentPath is available)
        let time, startTime;
        // ... (you need to set time and startTime)

        // Update the popup content for the current playback marker
        this.currentPlaybackMarker.setPopupContent(
          "<b> <i>[lat: </b>" +
          latitude +
          "<b> ,long: </b>" +
          longitude +
          "<b>]</i><br>" +
          time +
          ' </b>' +
          this.datePipe.transform(
            startTime,
            'dd/MM/yyyy HH:mm:ss',
            'en-US'
          )
        );

        this.currentPlaybackMarker.openPopup();

        this.playbackIndex++;
      } else {
        this.stopPlayback();
      }
    }, 1000); // Update every 1 second (adjust as needed)
  }

  stopPlayback() {
    this.playbackStarted = !this.playbackStarted; // Set to false when stopping
    if (this.playbackInterval) {
      clearInterval(this.playbackInterval);
      this.playbackInterval = null;
    }
    this.playbackIndex = 0;
  }


  currentPosition(vehicule:any, currentlocationlat:any, currentlocationlng:any) {
    this.showBackButton = true
    this.hideCurrentPath = true
    let vehicules = this.getVehicule(vehicule.idDevice);

    if (!this.isClicked) {
      this.mapService.map.flyTo(L.latLng(currentlocationlat, currentlocationlng), 15);
      this.positionMarker = L.marker([currentlocationlat, currentlocationlng]).addTo(this.mapService.map);
      this.circle = L.circle([currentlocationlat, currentlocationlng], {
        fillOpacity: 0.2,
        radius: 500
      }).addTo(this.mapService.map);

      this.isClicked = !this.isClicked;

    }
    else {
      this.mapService.map.removeLayer(this.positionMarker);
      this.mapService.map.removeLayer(this.circle);
      this.mapService.map.setView(L.latLng(vehicules[0].realTimeRecord.coordinate.lat, vehicules[0].realTimeRecord.coordinate.lng), 8);
      this.isClicked = !this.isClicked;
    }


  }
  async drawpath(vehicule: any, currentlocationlat: any, currentlocationlng: any) {
    this.hideCurrentPath = true;
    if (vehicule) {
      let vehicules = this.getVehicule(vehicule.idDevice);

      if (currentlocationlat && currentlocationlng) {
        try {
          await StartNavigation.launchMapsApp({
            latitude: vehicules[0].realTimeRecord.coordinate.lat,
            longitude: vehicules[0].realTimeRecord.coordinate.lng,
            name: vehicules[0].matricule,
            travelMode: "driving",
          });
          console.log('Navigation started successfully');
        } catch (error) {
          this.handleError(this.translate.instant('REALTIME.installGoogleMaps'));
        }
      } else {
        this.handleError(this.translate.instant('REALTIME.enableGps'));
      }
    } else {
      this.handleError(this.translate.instant('REALTIME.chooseVehicle'));
    }
  }


  async handleError(mess: String) {
    let alert = await this.alertCtrl.create({
      message: '' + mess,
      buttons: ['Ok']
    });
    await alert.present();
  }


}
